import { preparePayload } from 'helpers/person/personHelper'
import { http } from 'interfaces'
import { type BaseUrl, type Country } from 'services'

export interface PersonUrl extends BaseUrl {
  personId: number
}

export interface PersonBaseBasicInformation {
  id: number
  prefixId?: number
  firstName?: string
  middleName?: string
  lastName: string
  suffixId?: number
  profSuffix?: string
  legalName?: string
  nickname?: string
  pronunciation?: string
  ethnicId?: number
  genderId?: number
  maritalStatusId?: number
  partyId?: number
  religionId?: number
  birthMonth?: number | null
  birthDate?: number | null
  birthYear?: number
  birthplace?: string
  deathMonth?: number | null
  deathDate?: number | null
  deathYear?: number
  spouseName?: string
  residence?: string
  family?: string
  lastUpdated?: string
}

export interface PersonBasicInformation extends PersonBaseBasicInformation {
  uniqueId?: string
  prefixLocal?: string
  firstNameLocal?: string
  middleNameLocal?: string
  lastNameLocal?: string
  suffixLocal?: string
  profSuffixLocal?: string
  legalNameLocal?: string
  nicknameLocal?: string
  pronunciationLocal?: string
  spouseNameLocal?: string
  residenceLocal?: string
  familyLocal?: string
  urls: PersonUrl[]
  country: Country
  quorumProfileUrl?: string | null
}

export interface PersonUrlResponse {
  urls: PersonUrl[]
  sourceUrls: PersonUrl[]
}

export async function getPersonBasicInfo (personId: number): Promise<PersonBasicInformation> {
  return await http
    .get(`/api/v1/people/${personId}/`, {
    }).then(value => {
      const data = value.data
      if (data.urls == null) {
        data.urls = []
      }
      return data
    })
}

export async function updatePersonBasicInfo (personId: number, payload: any): Promise<number> {
  const newPayload = preparePayload(payload)

  return await http.put(`/api/v1/people/${personId}/`, newPayload)
    .then((response) => {
      return response.data.result.id
    })
}

export async function getUrlsByPerson (personId: number): Promise<PersonUrlResponse> {
  return await http
    .get(`/api/v1/people/${personId}/url/`, {})
    .then(value => value.data)
    .catch(() => { return [] })
}
